import { render, staticRenderFns } from "./ArticleCoverPage.vue?vue&type=template&id=096769b3&scoped=true"
import script from "./ArticleCoverPage.vue?vue&type=script&lang=js"
export * from "./ArticleCoverPage.vue?vue&type=script&lang=js"
import style0 from "./ArticleCoverPage.vue?vue&type=style&index=0&id=096769b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096769b3",
  null
  
)

export default component.exports